import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { SolarService } from 'src/app/services/cadastre-solaire/cadastre-solaire.service';
import { Profile, ProfileEnum } from 'src/app/models/Solar';
import { SolarThermalService } from 'src/app/services/cadastre-solaire/cadastre-solaire-thermal.service';

@Component({
    selector: 'cadastreSolaireProfile',
    templateUrl: './cadastre-solaire-profile.template.html',
    styleUrls: ['./cadastre-solaire-profile.component.scss'],
    standalone: false,
})
export class CadastreSolaireProfileComponent implements OnInit {
    public profileFormGroup: FormGroup;
    public isFormValid: boolean = false;

    public profiles: { label: string; value: Profile }[] = [
        { label: 'Je suis un particulier', value: ProfileEnum.INDIVIDUAL },
        { label: 'Je suis une entreprise', value: ProfileEnum.FIRM },
        { label: 'Je suis une collectivité', value: ProfileEnum.PUBLIC_AGENCY },
    ];

    constructor(
        @Inject(SolarService) public solarService: SolarService,
        @Inject(SolarThermalService) public solarThermalService: SolarThermalService,
    ) {}

    ngOnInit(): void {
        const initProfile = this.solarService.getProfile();
        this.profileFormGroup = new FormGroup({
            profile: new FormControl<ProfileEnum | null>(initProfile, Validators.required),
        });
        this.checkFormValidity();
        this.profileFormGroup.valueChanges.subscribe((values) => this.checkFormValidity());
    }

    public checkFormValidity() {
        this.isFormValid = this.profileFormGroup.status === 'VALID';
    }

    validate() {
        const selectedProfile = this.profileFormGroup.get('profile')?.value;
        this.solarService.setProfile(selectedProfile);

        if (selectedProfile !== ProfileEnum.INDIVIDUAL) {
            this.solarThermalService.setIncomeBracket(null);
        }
        this.solarService.updateMainStage('technologyStage');
    }

    cancel() {
        const isNew = this.solarService.checkIfSelectedElementsIsNew();
        const stage = isNew ? 'newRoofStage' : 'initStage';
        this.solarService.updateMainStage(stage);
    }
}
